import AuthLayout from "components/auth/AuthLayout";
import Layout from "layout/Layout";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";


const Auth = lazy(() => import("../components/auth/AuthLayout"));
const LoanMasterData = lazy(() => import("../components/views/admin/loan/LoanMasterData"));
const LoanHistory = lazy(() => import("../components/views/admin/loan/LoanHistory"));
const Assessment = lazy(() => import("../components/views/admin/loan/Assessment"));
const AdminDashboard = lazy(() => import("../components/views/admin/dashboard/AdminDashboard"));
const Error404 = lazy(() => import("../components/error/Error404"));
const Maintainance = lazy(() => import("../components/error/Maintainance"));
const DepartmentList = lazy(() => import("../components/views/superAdmin/department/DepartmentList"));
const OfficerList = lazy(() => import("../components/views/common/OfficerList"));

function DashboardRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route path="/loans" element={<LoanMasterData />} />
        <Route path="/details" element={<LoanHistory />} />
        <Route path="/assessment" element={<Assessment/>} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/departments" element={<DepartmentList />} />
        <Route path="/officer-list" element={<OfficerList />} />
        <Route path="/change-password" element={<Auth />} />
        <Route path="/404" element={<Error404 />} />
        <Route path="/maintainance" element={<Maintainance />} />
      </Route>
    </Routes>
  );
}

export default DashboardRoutes;
